__turbopack_context__.v({
  "className": "noto_sans_devanagari_a95559cc-module__xxdiAa__className",
});
